const filenameRegExp = /.+\/(.+)$/;

/**
 * @param path a full path or URL, like 'https://trqk-gap-analysis-reports-dev.s3.amazonaws.com/1635786456XX0000000000000X/my-file.zip'
 * @returns the filename with extension, like 'my-file.zip'
 */
export const getFilenameFromPath = (path: string): Maybe<string> => {
    const match = path.match(filenameRegExp);

    if (match === null) {
        return null;
    }

    return match[1];
};
